// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  thdCreditCard: {
    name: 'thd-credit-card',
    componentName: 'ThdCreditCard',
    chunk: () => import(
      /* webpackChunkName: "content-page" */
      './pages/ThdCreditCard'),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/ThdCreditCard.js'))
          .ThdCreditCard
        : currentRouteName === 'thd-credit-card'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ThdCreditCard })));
    },
    path: '/:context?/:myaccount?/thdcreditcard',
    channel: null
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  },
});
